module.exports = __webpack_public_path__ + "static/img/active2.11e49358.png";